import { types } from "../types/types";
const intitalState = {
    allPlans: [],
};

const plansReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.PLANS:
            return {
                ...state,
                allPlans: action.payload,
            };
        default:
            return { ...state };
    }
};

export default plansReducer;
